// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"e6cef3f5","540":"44775ebb","914":"307ea22d","961":"0a7f45be"}[chunkId] + ".js";
};